export default "__VITE_ASSET__Dqenysvk__"